import React from 'react';
import './ErrorBoundary.scss';
import { reportError } from '../../utils/errorReporting';
import { ClientErrorSource } from '../../models/ClientErrors/ClientErrorSource.enum';

export interface ErrorBoundaryProps {
    children: React.ReactNode;
}

interface ErrorBoundaryState {
    hasError: boolean;
}

export class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
    constructor(props: ErrorBoundaryProps) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(): ErrorBoundaryState {
        return { hasError: true };
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
        reportError(
            error?.message || 'Unknown application error',
            ClientErrorSource.ErrorBoundary,
            error?.stack ?? null,
            errorInfo?.componentStack ?? null
        );
    }

    handleReload = (): void => {
        window.location.reload();
    };

    render(): React.ReactNode {
        if (this.state.hasError) {
            return (
                <div className="error-boundary-page">
                    <div className="error-boundary-page__content">
                        <h2 className="error-boundary-page__title">Something went wrong</h2>
                        <p className="error-boundary-page__message">
                            We hit an unexpected error. Reloading the page usually fixes it.
                        </p>
                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={this.handleReload}>
                            Reload
                        </button>
                    </div>
                </div>
            );
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
